import React from "react";

import { Card } from "@/components/ui/card";

type SettingsIconSkeletonLoaderProps = {
  numberOfPlaceholder: number;
};

const SettingsIconSkeletonLoader: React.FC<SettingsIconSkeletonLoaderProps> = ({
  numberOfPlaceholder,
}) => {
  return (
    <div className="flex flex-wrap gap-4">
      {Array.from({ length: numberOfPlaceholder }).map((_, i) => (
        <Card
          key={i}
          className="h-[110px] w-[110px] animate-pulse rounded-lg bg-gray-100"
        />
      ))}
    </div>
  );
};

export default SettingsIconSkeletonLoader;
